
export class CompetitionLevelsItem {
    public id: number;
    public level: string;
    public viewOrder: string;
    public sublevels: Array<{ SubId: string, SubLevel: string, SubViewOrder: string }> = [];


    constructor(rawItem: any) {
        this.id = rawItem.Id;
        this.level = rawItem.Level;
        this.viewOrder = rawItem.ViewOrder;
        rawItem.SubLevels ? this.sublevels.concat(rawItem.SubLevels) : undefined;
    }


}